module.exports = __webpack_public_path__ + "media/images/landing/en/create-a7d748fdeb99db8b5e18fa6bad959907.webp";